


















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ColItemData, getUnitRiskAnalyze } from '@/api/common/analyze'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import {
  getSubDDL, copyArray, toDefaultStr, toDefaultInt, tryToStr, tryToInt
} from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'

import {
  PagePermissionState, PermissionData, FailedPermission
} from '@/store/modules/pagePermission'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const PagePermissionModule = namespace('pagePermission')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    PageList
  }
})
export default class AnalyzeUnitRisk extends Vue {
  public showMore: boolean = false
  @PagePermissionModule.Getter
  public pagePermission!: PagePermissionState
  get btnCtrl(): PermissionData {
    const s = this.pagePermission
    if (this.$route.path === s.pagePath) {
      return s.permission
    }
    return FailedPermission
  }
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public cols: ColItemData[] = []
  public list = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public groupByList: any[] = [
    { Key: 'Unit', Val: '文保单位' },
    { Key: 'City', Val: '城市' },
    { Key: 'Classify', Val: '文物分类' }
  ]
  public listLoading: boolean = true
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'UnitName',
    IsAsc: true,

    GroupBy: 'Unit',
    CityId: 0,
    CountyId: 0,
    Keyword: ''
  }
  // 保存最新的一次查询参数，用来保证分页，排序，导出时保证查询条件不变
  public lastQuery = Object.assign({}, this.queryTerm)
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'UnitName'),
      IsAsc: tryToStr(query['IsAsc']) == 'true',

      GroupBy: toDefaultStr(query['GroupBy'], 'Unit'),
      CityId: tryToInt(query['CityId']),
      CountyId: tryToInt(query['CountyId']),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    const qt = this.queryTerm
    const query = this.lastQuery
    query.Page = qt.Page
    query.PageSize = qt.PageSize
    this.refreshData()
  }
  public created() {
    this.getQueryTerm()
    this.fetchSource()
  }
  public mounted() {
    this.doSearch()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData(this.queryTerm)
  }
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  // 数据项加载
  public fetchSource() {
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
    }
  }
  public buildCols(source: ColItemData[]) {
    let keys: string[] = []
    let parents: ColItemData[] = []
    source.forEach((e: ColItemData, i: number) => {
      if (keys.findIndex(v => v == e.GroupType) == -1) {
        var n = Object.assign({}, e)
        n.Childs = [e]
        parents.push(n)
        keys.push(e.GroupType)
      } else {
        let parent = parents.find(v => v.GroupType == e.GroupType)
        if (parent) {
          parent.Childs.push(e)
        }
      }
    })
    this.cols = parents
  }
  public getSum(param: any) {
    const { columns, data } = param
    const sums: any = []
    columns.forEach((column: any, index: number) => {
      if (index === 0) {
        return
      }
      if (index === 1) {
        sums[index] = '总计'
        return
      }
      //合计的时候 el-table-column上的 prop参数一定要赋值，不然这边获取到的是undefined
      // console.log('column',column.property)
      const values = data.map((item: any) => Number(item[column.property]))
      if (!values.every((value: any) => isNaN(value))) {
        sums[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
        // sums[index] += ' 次'
      } else {
        sums[index] = 'N/A'
      }
    })
    return sums
  }
  public itemClick(row: any, child: any) {
    var url = child.GroupType == 'RiskLevel' ? '/UnitBuiltFireSafety' : '/CruiseEvent'
    url += '?' + child.GroupField + '=' + child.GroupId
    const groupBy = this.queryTerm.GroupBy
    if (groupBy == '' || groupBy == 'Unit') {
      url += '&Keyword=' + row.UnitCode
    }
    else {
      url += '&' + groupBy + 'Id=' + row.GroupId
    }
    // console.log(url)
    this.$router.push(url).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public groupField: string = 'UnitName'
  public groupLabel: string = '文保单位'
  public fetchData(query: any) {
    const qt = query
    this.groupField = 'GroupName'
    switch (qt.GroupBy) {
      case 'City':
        this.groupLabel = '城市'
        break
      case 'Level':
        this.groupLabel = '单位级别'
        break
      case 'Classify':
        this.groupLabel = '文物分类'
        break
      default:
        this.groupField = 'UnitName'
        this.groupLabel = '文保单位'
        break
    }
    this.listLoading = true
    getUnitRiskAnalyze(qt).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        // console.log(data)
        var obj = data.Results
        this.list = obj.source
        this.buildCols(obj.cols)
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount
        
        this.lastQuery = Object.assign({}, query)
      }
      this.listLoading = false
    })
  }
  public refreshData() {
    this.fetchData(this.lastQuery)
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getQueryTerm()
    const qt = this.queryTerm
    if (qt.CityId > 0) {
      this.cityChange(0)
    }
    this.doSearch()
  }
  public cityChange(reset: number) {
    const qt = this.queryTerm
    this.countyList = [this.defItem]
    if (reset === 1) {
      qt.CountyId = 0
    }
    if (qt.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, qt.CityId)
      if (this.countyList.length == 1) {
        qt.CountyId = this.countyList[0].Key
      }
    }
  }
}
